import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NewsSlideoutService {

  private newsClickedSource = new Subject<string>();
  newsClicked$ = this.newsClickedSource.asObservable();

  openNewsSlideout(newsId: string) {
    this.newsClickedSource.next(newsId);
  }
}
